import { FC, ReactNode } from "react";
import { Theme, themeRootClassMap } from "apps/website/maps/Theme.map";
import cx from "apps/website/utils/misc/cx";

import { Color } from "../Text/constant";
import TextSubtitle from "../Text/TextSubtitle/TextSubtitle";

export interface IHorizontalRuleStyleOptions {
  backgroundColour?: Theme;
  lineColour?: Theme;
  textColor?: Color;
  thin?: boolean;
}

export interface IHorizontalRuleProps {
  children: ReactNode;
  styleOptions?: IHorizontalRuleStyleOptions;
}

const HorizontalRule: FC<IHorizontalRuleProps> = ({
  children,
  styleOptions,
}) => {
  const lineColour = styleOptions?.lineColour ?? "dark";
  const textColor = styleOptions?.textColor ?? "default";
  const thin = styleOptions?.thin ?? false;

  const lineClass = themeRootClassMap[lineColour];
  const lineThickness = thin ? "h-[1.5px]" : "h-1";

  return (
    <div className="flex items-center gap-2">
      <div className={cx("flex-1", lineThickness, lineClass)}></div>
      <TextSubtitle
        size={3}
        align="center"
        color={textColor}
        className="inline-flex items-center gap-1 shrink-0"
      >
        { children }
      </TextSubtitle>
      <div className={cx("flex-1", lineThickness, lineClass)}></div>
    </div>
  );
};

export default HorizontalRule;
